export default __webpack_public_path__ + "static/SRC 3212 - Product Specifications & Technical Data-f23a30513d7664338ed88a06621f905e.pdf";